import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { ENABLE_BRAND_REVIEWS_HOLDOUT_XP_V2_250306 } from "@faire/web-api--source/indigofair/settings/ENABLE_BRAND_REVIEWS_HOLDOUT_XP_V2_250306";
import { useEffect } from "react";

import { useIsLoggedInRetailer } from "../lib/isLoggedInRetailer";

export const useSettingReviewsHoldoutXP = (): boolean => {
  return useSetting(ENABLE_BRAND_REVIEWS_HOLDOUT_XP_V2_250306, false);
};

export const useRolledOutReviewsHoldoutXPSetting = (): boolean => {
  return !useSettingReviewsHoldoutXP();
};

export const useReviewsHoldoutAssignSettingEffect = () => {
  const assignHoldoutSetting = useAssignSetting(
    ENABLE_BRAND_REVIEWS_HOLDOUT_XP_V2_250306
  );
  const isLoggedInRetailer = useIsLoggedInRetailer();

  useEffect(() => {
    if (isLoggedInRetailer) {
      assignHoldoutSetting();
    }
  }, [isLoggedInRetailer, assignHoldoutSetting]);
};
